import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromRollbackPaymentRun from '../reducers/rollback-payment-run.reducer';

export { RollbackPaymentRunState } from '../reducers/rollback-payment-run.reducer';

export const selectRollbackPaymentRunState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromRollbackPaymentRun.rollbackPaymentRunFeatureKey]
);

export const selectRollbackPaymentRunSuccess = createSelector(
  selectRollbackPaymentRunState,
  state => state?.success
);

export const selectRollbackPaymentRunFailure = createSelector(
  selectRollbackPaymentRunState,
  state => state?.failure
);

export const selectRollbackPaymentRunLoading = createSelector(
  selectRollbackPaymentRunState,
  state => state?.loading
);
